import multiguard from 'vue-router-multiguard';
import UserGuard from '../guards/User';

export default [
  {
    path: '/profile/settings',
    name: 'profileSetting',
    component: () => import(/* webpackChunkName: "profileSetting" */ '@/views/profile/Settings.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      // Settings page should not render the 2nd level submenu bar
      isMenu: false,
    },
  },
  {
    // Profile "About" page is removed; content is now a section inside Settings.
    // Keeping the URL for backward compatibility.
    path: '/profile/about',
    redirect: { name: 'profileSetting', hash: '#about' },
  },
  {
    path: '/profile/feed',
    name: 'profileFeed',
    component: () => import(/* webpackChunkName: "profileFeed" */ '@/views/profile/Feed/Index.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/friends',
    name: 'profileFriends',
    component: () => import(/* webpackChunkName: "profileFriends" */ '@/views/profile/Friends/Friends.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/groups',
    name: 'profileGroups',
    component: () => import(/* webpackChunkName: "profileGroups" */ '@/views/profile/MyGroups/Index.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/group/request',
    name: 'profileGroupsRequest',
    component: () => import(/* webpackChunkName: "profileGroupsRequest" */ '@/views/profile/MyGroups/Request/Index.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/projects',
    name: 'strategyProjects',
    component: () => import(/* webpackChunkName: "MyStrategyProjects" */ '@/views/profile/MyStrategyProjects.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/seller/products',
    redirect: '/profile/matchmaking/seller',
  },
  {
    path: '/profile/matchmaking/seller/saved',
    name: 'profileMatchmakingSellerSaved',
    component: () => import(/* webpackChunkName: "profileMatchmakingSellerProducts" */ '@/views/profile/Matchmaking/Seller/Products.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      sellerSavedView: true,
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/seller',
    name: 'profileMatchmakingSellerProducts',
    component: () => import(/* webpackChunkName: "profileMatchmakingSellerProducts" */ '@/views/profile/Matchmaking/Seller/Products.vue'),
    beforeEnter: multiguard([
      (to, from, next) => {
        if (to.query.type === 'projects') {
          const { type, ...query } = to.query;
          next({ name: 'profileMatchmakingSellerSaved', query });
        } else {
          next();
        }
      },
      UserGuard,
    ]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/seller/subscriptions',
    name: 'profileMatchmakingSellerSubscriptions',
    component: () => import(/* webpackChunkName: "profileMatchmakingSellerSubscriptions" */ '@/views/profile/Matchmaking/Seller/Subscriptions.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/buyer/subscriptions',
    name: 'profileMatchmakingBuyerSubscriptions',
    component: () => import(/* webpackChunkName: "profileMatchmakingBuyerSubscriptions" */ '@/views/profile/Matchmaking/Buyer/Subscriptions.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/seller/projects',
    name: 'profileMatchmakingSellerProjects',
    component: () => import(/* webpackChunkName: "profileMatchmaking" */ '@/views/profile/Matchmaking/Index.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      sellerProjects: true,
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/:type?',
    name: 'profileMatchmaking',
    component: () => import(/* webpackChunkName: "profileMatchmaking" */ '@/views/profile/Matchmaking/Index.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/:type/project/:id',
    name: 'projectDetails',
    component: () => import(/* webpackChunkName: "projectDetails" */ '@/views/profile/Matchmaking/Shared/Project.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/seller/product/:id',
    name: 'profileMatchmakingSellerProductDetails',
    component: () => import(/* webpackChunkName: "profileMatchmakingSellerProductDetails" */ '@/views/profile/Matchmaking/Seller/ProductDetails.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
  {
    path: '/profile/matchmaking/buyer/product/:id',
    name: 'profileMatchmakingBuyerProductDetails',
    component: () => import(/* webpackChunkName: "profileMatchmakingBuyerProductDetails" */ '@/views/profile/Matchmaking/Buyer/ProductDetails.vue'),
    beforeEnter: multiguard([UserGuard]),
    meta: {
      layout: 'profile-layout',
      settingLayout: {
        header: {
          transperent: false,
        },
      },
      isHeader: true,
      isMenu: true,
    },
  },
];
